import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from 'react-select/async';

export default class WarehouseLocation extends Base {
    constructor(props) {
        super(props);
        this.state = {
            warehouseId: props.WarehouseId,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/warehouselocation/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/warehouselocation/save", {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            warehouseId: this.state.warehouseId,
            title: this.state.data.record.title,
            location: this.state.data.record.location,
            parentId: this.state.data.record.parentId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setParent(e) {
        this.state.data.record.parentId = e.value;
        this.state.data.record.parentTitle = e.label;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات جایگاه انبار" : "افزودن جایگاه انبار جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400" />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">موقعیت</label>
                                            <input defaultValue={this.state.data.record.location} onChange={e => this.state.data.record.location = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="400" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <label className="form-label">والد</label>
                                        <SelectAsync
                                            defaultValue={this.state.data.record.parentId === this.getDefaultGuid() ? null : [{ label: this.state.data.record.parenTitle, value: this.state.data.record.parentId }]}
                                            isMulti={true}
                                            placeholder="والد"
                                            defaultOptions
                                            loadOptions={(inputValue, callback) => this.loadWarehouseLocationsOptions(inputValue, callback, this.state.warehouseId)}
                                            onChange={e => this.setParent(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}